// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__322sg","row":"ProcedureTreatmentSummary_row__3DgvW"};